module.exports = __webpack_public_path__ + "img/no-content.be8df30a.png";